module.exports = __webpack_public_path__ + "img/Radiology.982dfa56.svg";